import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

import { FileViewer } from 'libs/rendering';

import Paragraph from 'components/Paragraph';
import Button from 'components/Button';
import { Date } from 'apps/components/date';
import { Avatar } from 'apps/components/shared';

import { Center } from 'legacyComponents/styled/lib';
import {
  ConflictColumn,
  ContribFileHeader,
  ActionWrapper,
  ViewerWrapper,
  Status,
  NoFile,
  IconStyled,
} from 'apps/project/tabs/conflicts/styles';

@withNamespaces()
@observer
export class RemoteConflict extends React.Component {
  render() {
    const { conflicts, activeConflict, manager } = this.props;
    if (!conflicts?.length) return null;
    const conflict = conflicts.apps[activeConflict];
    const contrib = conflict.remoteContribution;
    const { creatorProfile } = contrib;

    const { shortVersion } = contrib;
    const { username } = creatorProfile;

    const header = (
      <ContribFileHeader>
        <Avatar
          src={imageSrc(
            creatorProfile.avatar,
            creatorProfile.imageFallbackPath,
            mainConf.imgSizes.profile.small,
          )}
          display='inline-block'
        />
        <div>
          <Paragraph>{contrib.title}</Paragraph>
          <Paragraph>
            <Trans>
              <a href='' target='_blank'>
                #{{ shortVersion }}
              </a>{' '}
              by {{ username }}, <Date value={contrib.lastUpdated} />
            </Trans>
          </Paragraph>
        </div>
      </ContribFileHeader>
    );
    const { remote, remoteStatus } = conflict;
    const removed = remoteStatus === 'REMOVED';
    const { SetResolution, resolution } = manager;

    const resolutionValue = removed ? null : remote.id;
    const isResolution =
      Object.keys(resolution.toJS()).includes(conflict.path) &&
      resolution.get(conflict.path) === resolutionValue;

    return (
      <ConflictColumn>
        {header}
        <ViewerWrapper>
          <Status red={removed}>{remoteStatus}</Status>
          {isResolution && <IconStyled name='success' />}
          {removed ? (
            <Center>
              <NoFile>
                <Trans>This file was deleted</Trans>
              </NoFile>
            </Center>
          ) : (
            <FileViewer file={remote} />
          )}
        </ViewerWrapper>
        <ActionWrapper>
          {isResolution ? null : (
            <Center>
              {removed ? (
                <Button
                  text={<Trans>Delete file</Trans>}
                  variant='destructive'
                  size='small'
                  onClick={() =>
                    SetResolution('delete', conflict, null, activeConflict)
                  }
                />
              ) : (
                <Button
                  text={<Trans>Pick file</Trans>}
                  size='small'
                  onClick={() =>
                    SetResolution('pick', conflict, remote.id, activeConflict)
                  }
                  outline
                />
              )}
            </Center>
          )}
        </ActionWrapper>
      </ConflictColumn>
    );
  }
}

RemoteConflict.propTypes = {
  conflicts: PropTypes.object,
  activeConflict: PropTypes.number,
  SetResolution: PropTypes.func,
  SetActiveConflict: PropTypes.func,
  manager: PropTypes.object,
};
